import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, List, Card, CardHeader, ListItem, ListItemText, ListItemIcon,
  Checkbox, Button, Divider } from '@mui/material'
import { intersection, union } from 'lodash'
import { not } from '../../_helpers/jsHelper'


export const TransferList = ({ leftInit, rightInit, handleSelect }) => {

  const [checked, setChecked] = useState([])
  const [left, setLeft] = useState(leftInit)
  const [right, setRight] = useState(rightInit)

  const leftChecked = intersection(checked, left)
  const rightChecked = intersection(checked, right)

  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1)
      newChecked.push(value)
    else
      newChecked.splice(currentIndex, 1)

    setChecked(newChecked)
  }

  const numberOfChecked = items => intersection(checked, items).length

  const handleToggleAll = items => () =>
    numberOfChecked(items) === items.length
      ? setChecked(not(checked, items))
      : setChecked(union(checked, items))

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked))
    setLeft(not(left, leftChecked))
    setChecked(not(checked, leftChecked))
    handleSelect(right.concat(leftChecked))
  }

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked))
    setRight(not(right, rightChecked))
    setChecked(not(checked, rightChecked))
    handleSelect(not(right, rightChecked))
  }

  const customList = (title, items) => (
    <Card>
      <CardHeader
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
        sx={{ py: 1, px: 2 }}
      />
      <Divider />
      <List dense component='div' role='list' sx={{
        width: 200,
        height: 230,
        bgcolor: 'background.paper',
        overflow: 'auto',
      }}>
        {items.map(value => {
          const labelId = `transfer-list-all-item-${value}-label`

          return (
            <ListItem key={value} role='listitem' onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value} />
            </ListItem>
          )
        })}
        <ListItem />
      </List>
    </Card>
  )

  return (
    <Grid container spacing={2} justifyContent='center' alignItems='center'>
      <Grid item>{customList('Choices', left)}</Grid>
      <Grid item>
        <Grid container direction='column' alignItems='center'>
          <Button
            variant='outlined'
            size='small'
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label='move selected right'
            sx={{ my: .5 }}
          >
            &gt;
          </Button>
          <Button
            variant='outlined'
            size='small'
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label='move selected left'
            sx={{ my: .5 }}
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList('Chosen', right)}</Grid>
    </Grid>
  )
}

TransferList.propTypes = {
  leftInit: PropTypes.array.isRequired,
  rightInit: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired,
}

export default TransferList
